import { render, staticRenderFns } from "./UserFilter.vue?vue&type=template&id=70d9ac16&scoped=true&"
import script from "./UserFilter.vue?vue&type=script&lang=js&"
export * from "./UserFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d9ac16",
  null
  
)

export default component.exports